import React from 'react';
import Layout from './components/layout';
import Footer from './components/Footer';
import Routingpage from './Routingpage';



function App() {
  return (
    <>
     {/* <Layout/> */}
     {/* <Footer/> */}
     <Routingpage/>
    </>
  );
}

export default App;
